// extracted by mini-css-extract-plugin
module.exports = {"container":"UserMenu_container__2sXSb","button":"UserMenu_button__2vSr8","link":"UserMenu_link__2yeZC"};